<template>
  <div class="">
    <broker-statements />
  </div>
</template>

<script>
import BrokerStatements from "@/components/accounting/accounting-prod/broker-statements/index.vue";
export default {
  props: {
    msg: String,
  },
  components: {
    BrokerStatements,
  },
  created() {},
};
</script>
